<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月23日 13:36:30 +0800
 * @最后修改时间: 2021-11-22 10:02:01
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterFormRecord\components\newManager.vue
 -->
<template>
  <normalDialog
    :dialog="show"
    width="1000"
    maxWidth="1000"
    :title="$t('label_essweb_RosterFormRecord_form_dialog_editManagerTitle')"
    @close="closePorpertyDialog"
  >
    <template v-slot:content>
      <Tabler
        :headers="headers"
        itemKey="staff_id"
        :defaultSelect="selected"
        :items="desserts"
        :height="500"
        @select="(sel) => (selected = sel)"
        :showSelect="showSelect"
      >
        <template v-slot:item.staffid="{ item }">{{
          item.staff_code ? item.staff_code : item.staff_id
        }}</template>
        <template v-slot:item.name="{ item }">
          <v-list-item dense class="pa-0" style="max-width: 200px" two-line>
            <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
              <StaffAvatar
                size="36"
                :src="item.staff_avatar"
                :staff_name="item.preferred_name"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text--primary"
                >{{ $getCommonLangValue(item.preferred_name) }}
                <span class="text--secondary text-caption-xs">
                  {{ item.staff_code }}</span
                ></v-list-item-title
              >
              <v-list-item-subtitle>{{
                $getCommonLangValue(item.job_post_name)
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </Tabler>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="closePorpertyDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newManager",
  computed: {
    curSelect() {
      const that = this;
      let arr = [];
      this.desserts.map((item) => {
        if (that.curManageList.indexOf(item.staff_id) != -1) {
          arr.push(item);
        }
      });
      return arr;
    },
  },
  props: {
    show: { default: false, type: Boolean },
    curManageList: { default: [], type: Array },
  },
  watch: {
    show(val) {
      const that = this;
      if (val) {
        this.$Sleep(500).then(() => {
          that.selected = [];
          let arr = [];
          that.desserts.map((item) => {
            if (that.curManageList.indexOf(item.staff_id.toString()) != -1) {
              arr.push(item);
            }
          });
          that.selected = arr;
        });
      } else {
        this.selected = [0];
      }
    },
    curSelect(val) {
      this.selected = val;
    },
  },
  mounted() {
    this.$getStaffList().then((res) => {
      this.desserts = res;
    });
  },
  data() {
    return {
      headers: [
        {
          text: "label_essweb_shiftTypeMapping_list_staffIdLabel",
          value: "staffid",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shiftTypeMapping_list_staffNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      selected: [],
      showSelect: true,
      desserts: [],
      search: "",
    };
  },
  methods: {
    closePorpertyDialog: function () {
      this.$emit("close");
    },

    // 改为底层接口 daveluo
    // getList: function () {
    //   const that = this;
    //   this.$Request({
    //     method: "POST",
    //     table: "mrbase_sys_staffs",
    //     url: "/staff/get-staff-list/",

    //   }).then((res) => {
    //     that.desserts = res.data;
    //   });
    // },
    toSave: function () {
      this.$emit("onSave", this.selected);
      this.closePorpertyDialog();
    },
  },
};
</script>
